angular.module('mtic').service('language', function ($http, $cookies, $log, EventManager, API_CONFIG, LANGUAGE_TEXT, LANGUAGE_TEXT_SLUGS, LANGUAGE_SLUG_LINK, BRANDING, $rootScope) {
    // Init Event Manager
    var eventManager = new EventManager('language');

    // Private variables
    var languageOptionMap = {
        'fr': 'FRANÇAIS',
        'en': 'ENGLISH',
        'de': 'DEUTSCH',
        'pt': 'PORTUGUÊS'
    }
    var forceNew = []
    var activeLanguageOptions = [];
    // var currentSelectedLanguage = $cookies.get('bar_language') || 'fr';
    var currentSelectedLanguage = 'fr';
    var languageText = LANGUAGE_TEXT || {};
    var failedGets = [];
    var transpacks = {};
    var TRANPACK_PREFIX = 'TRANPACK://';

    /**
     * Builds a url to get a language id
     * @param  {String}
     * @return {String}
     */
    var urlBuilder = function(url){
        return 'https://mathematic-language.vretta.com/' + url
    }
    /**
     * Gets a language text by a slug name
     * used mostly for lessons in the modules
     * will be deprected
     * @param  {String}
     * @return {String}
     */
    var getBySpecialSlugName = function(slugName, allowNull) {
      // $log.warn('[[language]] @@Temporary using a temporay method `language.get.getBySpecialSlugName`, please make sure that', slugName, 'has a languageId!')
      if(LANGUAGE_TEXT_SLUGS[slugName]){
        return LANGUAGE_TEXT_SLUGS[slugName]
      } else {
        if(!allowNull) {
            failedGets.push(slugName);
            // $log.error('[[language]] could not find SpecialSlugName translation for ' + slugName)
        }
        return {}
      }
    }
    /**
     * Get Language Id from slug
     * @param  {String} slugName
     * @return {Null<Object>}
     */
    var getLangIdFromSlug = function(slugName) {
      if(LANGUAGE_SLUG_LINK[slugName]) {
        return LANGUAGE_SLUG_LINK[slugName];
      }else{
        return null;
      }
    }
    /**
     * Checks if the JSON is empty
     * @param  {Object} obj
     * @return {Boolean}
     */
    var objectIsEmpty = function(obj) {
      for(var key in obj) {
        if(obj.hasOwnProperty(key)) {
          return false;
        }
      }
      return true;
    }
    /**
     * Gets a language id
     * @param  {Integer}
     * @return {String}
     */
    var getLanguage = function(id, allowNull, makeHttpCall){
        if(!id) {
          return {};
        }

        if (id && ((''+id).substr(0, TRANPACK_PREFIX.length) === TRANPACK_PREFIX) ){          
          // TODO 
          var translation_slug = id.substr(TRANPACK_PREFIX.length, id.length);
          var pack_id = translation_slug.split('/')[0];
          var translation_id = translation_slug.split('/')[1];
          
          if(transpacks[pack_id] && transpacks[pack_id][translation_id]){
            return transpacks[pack_id][translation_id];
          }
          return {}
        }

        if(getLangIdFromSlug(id)) {
          id = getLangIdFromSlug(id)
        }

        if( isNaN(id) ) {
          var text = getBySpecialSlugName(id, allowNull);
          if(objectIsEmpty(text)) {
            return Object.keys(languageOptionMap).reduce(function(obj, langId) {
              obj[langId] = id
              return obj;
            },{});
          }
          return text;
        }

        if( !languageText[Number(id)] || forceNew.indexOf(id) > -1 ){
          languageText[id] = Object.keys(languageOptionMap).reduce(function(obj, langId) {
            obj[langId] = '...'
            return obj;
          },{});
          failedGets.push(id);
          if(makeHttpCall){
            $http({method: 'GET',url: urlBuilder('get_text'), params: {ids: id}}).then(function(data){
              var textObj = data.data[0];
              newIds[id] = languageText[id] = textObj;
              window._redefined_clean_lang_text = _.keys(languageText).reduce( (obj,k) => { if(!isNaN(k)) { obj[k]=languageText[k] } return obj;},{});
            }).catch(function(err){
              $log.error('[[language]] Failed to get language id ' + id)
            })
          }
        }
        return languageText[Number(id)];
    }

    // Public Methods
    var language = {
      /**
       * Reset the language options to default
       */
        resetAvilableOptions: function(){
            this.setAvailableOptions(['fr', 'en', 'de', 'pt'])
        },

        getMomentLocale: function(){
          switch( eventManager.getLanguage() ){
            case 'en': return 'en';
            case 'fr': return 'fr';
            case 'pt': return 'pt';
            case 'de': return 'de';
          }
          return 'en'
        },

        /**
         * Sets the language options
         * @param {Array<String>}
         */
        setAvailableOptions: function(languageSlugs){
          if (!languageSlugs){
            return;
          }
          $log.debug("[[language]] languageSlugs: ", languageSlugs);
          activeLanguageOptions = languageSlugs.map(function(languageOption){
            return {
              slug: languageOption,
              text: languageOptionMap[languageOption]
            }
          })
          if(languageSlugs.indexOf(currentSelectedLanguage) === -1){
            this.set(languageSlugs[0], true)
          }
          eventManager.broadcast("language:options:change");
        },
        /**
         * Sets the current language
         * @param {String}
         */
        set: function(slug, is_forced){
            if (slug) {
                  currentSelectedLanguage = slug;
                  // $cookies.put('bar_language', slug, {
                  //       expires: moment()
                  //             .add(2, 'hours')
                  //             .toDate()
                  // });
            }
            eventManager.setLanguage(slug, is_forced)            
            moment.locale(slug);
        },
        /**
         * Grabs a language text by its id
         * @param  {String}
         * @param  {Object}
         * @return {String}
         */
        get: function(id, params, allowNull){
            if($rootScope.branding === BRANDING.OCMT){
              currentSelectedLanguage = 'en';
            }
            var text = getLanguage(id, allowNull)[currentSelectedLanguage];

            if(typeof text === 'object' && text.val){
              text= text.val;
            }
            
            if(text === null){
                return '';
            }else{
              if(text === 'NA' && getLanguage(id, allowNull).en !== null && getLanguage(id, allowNull).en !== 'NA'){
                text = getLanguage(id, allowNull).en;
              }
                if (params && params.length > 0) {
                    params.forEach(function (param) {
                        text = text.replace('{{' + param.name + '}}', param.value);
                    });
                }
                return text;
            }
        },
        /**
         * gets the current language slug (or name)
         * @param  {Boolean}
         * @return {String}
         */
        getCurrentSelectedLanguage: function(pretty){
          if(pretty){
            return languageOptionMap[currentSelectedLanguage]
          }else{
            return currentSelectedLanguage
          }
        },
        /**
         * gets a list of the current language options
         * @return {Array<Object>}
         */
        getActiveLanguageOptions: function(){
          return activeLanguageOptions
        },

        getBySpecialSlugName: function(id, allowNull){
            $log.warn('[[language]] @@Deprecated using a Deprecated method `language.getBySpecialSlugName`, please use `language.get` instead!')
            return getBySpecialSlugName(id,allowNull)[currentSelectedLanguage]
        },
        
    }

    language.loadTranspacks = function(tran_packs){
      var tran_packs_safe = encodeURIComponent(JSON.stringify(tran_packs));
      $http.get(API_CONFIG.PDF_API+'/translation-packs?packIds='+tran_packs_safe+'&apiUrl='+encodeURIComponent(API_CONFIG.REMOTE_API))
      .then(function(data){
        var translations = data.data;
        _.each(translations, function(pack, pack_id){
          if(!transpacks[pack_id]){
            transpacks[pack_id] = {};
          }
          if(pack.elements){
            _.each(pack.elements, function(el){
              if(el){
                if(typeof el === 'string'){
                  el = JSON.parse(el);
                }
                if(el.id && el.id.pack_element_id){
                  transpacks[pack_id][el.id.pack_element_id] = el.text;
                }
                
              }
            })
          }
        })
        
        $log.log('transpack loaded : ' , transpacks)
      });
    }

    // Use default language
    language.resetAvilableOptions()

    if(forceNew && forceNew.length > 0) {
      var newIds = window.newIds = {};
      forceNew.map(function(tId) {
        $log.debug('Getting', tId);
        getLanguage(tId, true, true)
      });
      $log.debug("new translations!", newIds)
    }
    window._lang_failed_gets = failedGets;
    return language;
})
